import adminAuth from './adminAuth';
import selectedProduct from './selectedProduct';
import { useAppStore } from '@/store/app';

const appRehydrate = () => {
  adminAuth();
  selectedProduct();
  const store = useAppStore();
  store.fetchAllSubscriptionTypes();
  store.fetchAllBetMakersSubLevels();
  store.fetchAllBetMakersProducts();
};

export default appRehydrate;
